import React, { Component } from "react";
import Menu from "./Menu";

class About extends Component {
	render() {
		return (
			<div>
				<Menu selected='about' />
				<div className='row maincontent shadow'>
					<div className='col'>
						<h1>About</h1>
					</div>
					<div className='row justify-content-center'>
						<div className='col-6 text-center'>
							<img src='https://picsum.photos/300/300' alt='' />
							<p>
								Lorem ipsum dolor sit amet consectetur adipisicing elit.
								Quaerat, asperiores laudantium. Blanditiis eaque possimus,
								temporibus pariatur doloremque obcaecati magni laudantium
								laboriosam corrupti fugit quo ipsum impedit, sint perspiciatis
								quod labore.
							</p>
							<p>
								Cum voluptas earum beatae reprehenderit itaque? Tempora, fugiat
								possimus voluptatum blanditiis odit voluptatibus ducimus
								repudiandae labore. Nostrum, doloribus! Velit et nobis
								aspernatur ab quae iusto qui quis temporibus fugiat. Eligendi.
								Consequuntur eum fuga sapiente voluptatem expedita, ullam qui
								numquam velit corrupti ex harum eius, officiis laborum, quia
								quam aperiam facilis quaerat beatae? Iste earum culpa error
								minima a laboriosam eum!
							</p>
						</div>
					</div>
				</div>
			</div>
		);
	}
}

export default About;
